import { render, staticRenderFns } from "./RecipesMobileCard.vue?vue&type=template&id=3303d934"
import script from "./RecipesMobileCard.vue?vue&type=script&lang=js"
export * from "./RecipesMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports